<template>
  <Card class="mb-2">
    <v-card-title class="cardTitle pa-0">{{ $t('Причины отсутствия победителя') }}</v-card-title>
    <template v-for="(reason) in props.cancellationReasons" :key="reason.id">
      <v-card-text class="pa-0">
        {{ reason.explanation }}
      </v-card-text>
    </template>
  </Card>
</template>

<script setup lang="ts">
import Card from '@intec/vue-components/form/Card.vue';

interface Props {
  cancellationReasons: Array<{id: Number, explanation: string}>,
}

const props = withDefaults(defineProps<Props>(), {
  cancellationReasons: [],
});
</script>

<style scoped lang="scss">
.v-card-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
</style>
